<template>
    <section class="bannerBox">
        <div class="banner" @mousemove.stop="bannerMove" ref="banner" @mouseenter="changeHideClass(false)" @mouseleave="changeHideClass(true)"  v-if="bannerImglist && bannerImglist.length>0">
            <swiper :options="swiperOption" ref="mySwiper">
                <!-- slides -->
                <swiper-slide v-for="item in bannerImglist" :key="item.id"><img :src="$root.$TEMP_URL+item.pic" /></swiper-slide>

            </swiper>
            <!-- 左右箭头 -->
            <div v-show="isLeftShow" :class="hideClass?'bannerSwiperLeft fa fa-angle-left hide':'bannerSwiperLeft fa fa-angle-left'" ref="bannerSwiperLeft"></div>
            <div v-show="!isLeftShow" :class="hideClass?'bannerSwiperRight fa fa-angle-right hide':'bannerSwiperRight fa fa-angle-right'" ref="bannerSwiperRight"></div>
        </div>
    </section>
</template>

<script>
import { getBanner,getBannercn } from '../../api'
import 'swiper/dist/css/swiper.css'

// 全使用swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper' 
// import Vue from 'vue'
// Vue.use(VueAwesomeSwiper)

//局部使用
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    data() {
        return {
            bannerImglist:[],
            swiperOption: {
               loop: true,　　//是否自动轮播
　　　　　　　　autoplay: false,  //l轮播间隔时间
　　　　　　　　navigation: {
                    nextEl: '.bannerSwiperRight',
                    prevEl: '.bannerSwiperLeft',
                }
    　　　　 },
            isLeftShow:true,
            //存在hide
            hideClass:true,
            isZhong:false

        };
    },
    components:{
        swiper,
        swiperSlide
    },
    async created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong;
        let res;
        if(isZhong){
            res = await getBannercn();
        }else{
            res = await getBanner();
        }
        this.bannerImglist = res.data;

    },
    methods: {
        //鼠标移动，改变hideClass
        changeHideClass(status){
            this.hideClass = status;
        },
        //在banenr上移动鼠标
        bannerMove(e){
            const bannerWidth = this.$refs.banner.clientWidth;
            let currentPageX = e.pageX;
            let currentPageY = e.pageY;
            
            if(currentPageX <= bannerWidth/2){
                this.isLeftShow = true;
                this.$refs.bannerSwiperLeft.style.left = currentPageX+'px';
                this.$refs.bannerSwiperLeft.style.top = (currentPageY)+'px';

            }else{
                this.isLeftShow = false;

                this.$refs.bannerSwiperRight.style.left = currentPageX+'px';
                this.$refs.bannerSwiperRight.style.top = currentPageY+'px';
            }
        }
    },
    watch:{
        
    }
   
};
</script>

<style lang="scss" scoped>
.bannerBox{
    width: 100%;
    .banner{
        width: 100%;
        position: relative;
        img{
            width: 100%;
        }
    }
}
//banner左右箭头
.bannerSwiperLeft,.bannerSwiperRight{
  position: absolute;
  top: 41%;
  left: 0;
  z-index: 9;
  color: #fff;
  font-size: 88px;
  margin-top: -44px;
  margin-left: -6px;
  outline: none;
}
.bannerSwiperLeft.hide,.bannerSwiperRight.hide{
  display: none !important;
}
@media screen and (max-width: 1199px) {
    .bannerSwiperLeft,.bannerSwiperRight{
        display: none !important;
    }
}


</style>


// WEBPACK FOOTER //
// src/components/Banner/Banner.vue